import axios from "axios";
import {
	CandidateCreate,
	CandidateFilter,
	CandidatePageData,
	CandidateSearch,
	CandidateTable,
} from "../interfaces/Candidate";
import {
	CommentData,
	CommentFilter,
	CommentSearch,
	CommentTable,
} from "../interfaces/Comment";
import {
	InterviewCreate,
	InterviewFilter,
	InterviewSearch,
	InterviewTable,
} from "../interfaces/Interview";
import {
	LetterCreate,
	LetterFilter,
	LetterSearch,
	LetterTable,
} from "../interfaces/Letter";
import {
	LetterTemplateCreate,
	LetterTemplateFilter,
	LetterTemplateSearch,
	LetterTemplateTable,
} from "../interfaces/LetterTemplate";
import {
	ManagerAuth,
	ManagerAuthResponse,
	ManagerCreate,
	ManagerFilter,
	ManagerSearch,
	ManagerTable,
} from "../interfaces/Manager";
import Region, {
	CityCreate,
	CityDelete,
	CityUpdate,
	RegionCreate,
	RegionDelete,
	RegionUpdate,
} from "../interfaces/Region";
import {
	RequestCreate,
	RequestFilter,
	RequestSearch,
	RequestTable,
} from "../interfaces/Request";
import {
	ArrayContainer,
	Filter,
	ResponseContainer,
} from "../interfaces/RequestBase";
import Resume, { ResumeFilter, ResumeList } from "../interfaces/Resume";
import { RoleList } from "../interfaces/Role";
import { Status, StatusFilter } from "../interfaces/Status";
import {
	TaskCreate,
	TaskFilter,
	TaskSearch,
	TaskTable,
} from "../interfaces/Task";
import {
	ApprovedTest,
	TestCreate,
	TestFilter,
	TestSearch,
	TestTable,
	UserTest,
} from "../interfaces/Test";
import {
	ProbationCreate,
	VacancyCreate,
	VacancyFilter,
	VacancySearch,
	VacancyTable,
} from "../interfaces/Vacancy";
import Specilization, { Direction } from "../pages/Specilization";
import request, { MAIN_URL, P } from "./requester";

// Requests
export function GetRequests(
	args: Filter<RequestFilter, RequestSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<RequestTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<RequestTable>>>(
		P.RequestsList,
		args,
		callback
	);
}

export function GetRequest(
	args: { id: number },
	callback: (resp: ResponseContainer<RequestTable>) => void
) {
	request<ResponseContainer<RequestTable>>(P.RequesGet, args, callback);
}

export function UpdateRequest(
	args: RequestCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.RequestUpdate, args, callback);
}

export function CreateRequest(
	args: RequestCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.RequestCreate, args, callback);
}

// Tasks
export function GetTasks(
	args: Filter<TaskFilter, TaskSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<TaskTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<TaskTable>>>(
		P.TaskList,
		args,
		callback
	);
}

export function GetTask(
	args: { id: number },
	callback: (resp: ResponseContainer<TaskTable>) => void
) {
	request<ResponseContainer<TaskTable>>(P.TaskGet, args, callback);
}

export function UpdateTask(
	args: TaskCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.TaskUpdate, args, callback);
}

export function CreateTask(
	args: TaskCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.TaskCreate, args, callback);
}

// Comments
export function GetComments(
	args: Filter<CommentFilter, CommentSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<CommentTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<CommentTable>>>(
		P.CommentList,
		args,
		callback
	);
}

export function CreateComment(
	args: { data: CommentData; file: any },
	callback: (resp: ResponseContainer<any>) => void
) {
	var data = new FormData();
	data.append("data", JSON.stringify(args.data));
	data.append("file", args.file);

	axios
		.post(MAIN_URL + P.CommentCreate, data, {
			withCredentials: true,
			headers: { "Content-Type": "multipart/form-data" },
		})
		.then(function (response) {
			callback(response.data as ResponseContainer<any>);
		})
		.catch(function (response) {
			console.error(response);
		});
}

// Interviews
export function GetInterviews(
	args: Filter<InterviewFilter, InterviewSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<InterviewTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<InterviewTable>>>(
		P.InterviewList,
		args,
		callback
	);
}

export function GetInterview(
	args: { id: number },
	callback: (resp: ResponseContainer<InterviewTable>) => void
) {
	request<ResponseContainer<InterviewTable>>(P.InterviewGet, args, callback);
}

export function UpdateInterview(
	args: InterviewCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.InterviewUpdate, args, callback);
}

export function CreateInterview(
	args: InterviewCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.InterviewCreate, args, callback);
}

export function DeleteInterview(
	args: { id: number },
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.InterviewDelete, args, callback);
}

// Letters
export function GetLetters(
	args: Filter<LetterFilter, LetterSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<LetterTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<LetterTable>>>(
		P.LetterList,
		args,
		callback
	);
}

export function UpdateLetter(
	args: LetterCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterUpdate, args, callback);
}

export function CreateLetter(
	args: LetterCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterCreate, args, callback);
}

export function DeleteLetter(
	args: { id: number; is_delete: boolean },
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterDelete, args, callback);
}

// Templates
export function GetLetterTemplates(
	args: Filter<LetterTemplateFilter, LetterTemplateSearch>,
	callback: (
		resp: ResponseContainer<ArrayContainer<LetterTemplateTable>>
	) => void
) {
	request<ResponseContainer<ArrayContainer<LetterTemplateTable>>>(
		P.LetterTemplateList,
		args,
		callback
	);
}

export function GetLetterTemplate(
	args: { id: number },
	callback: (resp: ResponseContainer<LetterTemplateTable>) => void
) {
	request<ResponseContainer<LetterTemplateTable>>(
		P.LetterTemplateGet,
		args,
		callback
	);
}

export function UpdateLetterTemplate(
	args: LetterTemplateCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterTemplateUpdate, args, callback);
}

export function CreateLetterTemplate(
	args: LetterTemplateCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterTemplateCreate, args, callback);
}

export function DeleteLetterTemplate(
	args: { id: number; is_delete: boolean },
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.LetterTemplateDelete, args, callback);
}

// Managers
export function CreateManager(
	args: { manager: ManagerCreate; image: any },
	callback: (resp: ResponseContainer<null>) => void
) {
	var data = new FormData();
	data.append("data", JSON.stringify(args.manager));
	data.append("img", args.image);

	const headers = {
		"Content-Type": "multipart/form-data",
	};

	request<ResponseContainer<null>>(P.CreateManager, data, callback, headers);
}

export function EditManager(
	args: { manager: ManagerCreate; image?: any },
	callback: (resp: ResponseContainer<null>) => void
) {
	var data = new FormData();
	data.append("data", JSON.stringify(args.manager));
	data.append("img", args.image);

	const headers = {
		"Content-Type": "multipart/form-data",
	};

	request<ResponseContainer<null>>(P.ManagerUpdate, data, callback, headers);
}

export function Logout(callback: (resp: ResponseContainer<null>) => void) {
	request<ResponseContainer<null>>(P.Logout, {}, callback);
}

export function GetManagers(
	args: Filter<ManagerFilter, ManagerSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<ManagerTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<ManagerTable>>>(
		P.ManagerList,
		args,
		callback
	);
}

export function GetManager(
	args: { id_manager: number },
	callback: (resp: ResponseContainer<ManagerCreate>) => void
) {
	request<ManagerTable>(P.ManagerGet, args, callback);
}

export function Auth(
	args: ManagerAuth,
	callback: (resp: ResponseContainer<ManagerAuthResponse>) => void
) {
	request<ManagerAuthResponse>(P.Auth, args, callback);
}

export function Check(
	args: {},
	callback: (resp: ResponseContainer<ManagerAuthResponse>) => void
) {
	request<ManagerAuthResponse>(P.CheckManager, args, callback);
}

export function GetRoles(
	args: {},
	callback: (resp: ResponseContainer<RoleList[]>) => void
) {
	request<RoleList[]>(P.RoleList, args, callback);
}

export function CreateCandidate(
	args: CandidateCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.CreateCandidate, args, callback);
}

export function GetCandidates(
	args: Filter<CandidateFilter, CandidateSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<CandidateTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<CandidateTable>>>(
		P.CandidateList,
		args,
		callback
	);
}

export function GetCandidate(
	args: { id_candidate: number },
	callback: (resp: ResponseContainer<CandidatePageData>) => void
) {
	request<ResponseContainer<CandidatePageData>>(P.Candidateget, args, callback);
}

export function GetRegions(
	args: {},
	callback: (resp: ResponseContainer<Region[]>) => void
) {
	request<ResponseContainer<Region[]>>(P.RegionList, args, callback);
}

export function UpdateCandidate(
	args: CandidatePageData,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.CandidateUpdate, args, callback);
}

export function UpdateRegionCity(
	args: CityUpdate | RegionUpdate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.RegionUpdate, args, callback);
}

export function CreateRegionCity(
	args: RegionCreate | CityCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.CreateRegionCity, args, callback);
}

export function DeleteRegionCity(
	args: RegionDelete | CityDelete,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.RegionDelete, args, callback);
}

export function GetVacancies(
	args: Filter<VacancyFilter, VacancySearch>,
	callback: (resp: ResponseContainer<ArrayContainer<VacancyTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<VacancyTable>>>(
		P.VacancyList,
		args,
		callback
	);
}

export function GetProbations(
	args: Filter<VacancyFilter, VacancySearch>,
	callback: (resp: ResponseContainer<ArrayContainer<VacancyTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<VacancyTable>>>(
		P.ProbationList,
		args,
		callback
	);
}

export function DeleteVacancy(
	args: { id: number; is_delete: boolean },
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.VacancyDelete, args, callback);
}

export function GetSpecilizations(
	args: {},
	callback: (resp: ResponseContainer<Specilization[]>) => void
) {
	request<ResponseContainer<Specilization[]>>(
		P.SpecilizationList,
		args,
		callback
	);
}

export function GetDirections(
	args: {},
	callback: (resp: ResponseContainer<Direction[]>) => void
) {
	request<ResponseContainer<Direction[]>>(P.DirectionList, args, callback);
}

// Vacancies
export function GetVacancy(
	args: { id: number },
	callback: (resp: ResponseContainer<VacancyCreate>) => void
) {
	request<ResponseContainer<VacancyCreate>>(P.VacancyGet, args, callback);
}

export function CreateVacancy(
	args: VacancyCreate,
	callback: (resp: ResponseContainer<{ id: number }>) => void
) {
	request<ResponseContainer<{ id: number }>>(P.VacancyCreate, args, callback);
}

export function UpdateVacancy(
	args: VacancyCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<VacancyCreate>>(P.VacancyUpdate, args, callback);
}

// Probations
export function GetProbation(
	args: { id: number },
	callback: (resp: ResponseContainer<ProbationCreate>) => void
) {
	request<ResponseContainer<ProbationCreate>>(P.ProbationGet, args, callback);
}

export function CreateProbation(
	args: ProbationCreate,
	callback: (resp: ResponseContainer<{ id: number }>) => void
) {
	request<ResponseContainer<{ id: number }>>(P.ProbationCreate, args, callback);
}

export function UpdateProbation(
	args: ProbationCreate,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<ProbationCreate>>(
		P.ProbationUpdate,
		args,
		callback
	);
}

export function DeleteProbation(
	args: { id: number; is_delete: boolean },
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.ProbationDelete, args, callback);
}

// Resumes
export function GetResumes(
	args: Filter<ResumeFilter, null>,
	callback: (resp: ResponseContainer<ArrayContainer<ResumeList>>) => void
) {
	request<ResponseContainer<ArrayContainer<ResumeList>>>(
		P.ResumeList,
		args,
		callback
	);
}

export function GetResume(
	args: { id: number },
	callback: (resp: ResponseContainer<Resume>) => void
) {
	request<ResponseContainer<Resume>>(P.ResumeGet, args, callback);
}

export function Createresume(
	args: { data: Resume; file: any },
	callback: (resp: ResponseContainer<any>) => void
) {
	var data = new FormData();
	data.append("data", JSON.stringify(args.data));
	data.append("doc", args.file);

	axios
		.post(MAIN_URL + P.ResumeCreate, data, {
			withCredentials: true,

			headers: { "Content-Type": "multipart/form-data" },
		})
		.then(function (response) {
			callback(response.data as ResponseContainer<any>);
		})
		.catch(function (response) {
			console.error(response);
		});
}

export function Updateresume(
	args: { data: Resume; file: any },
	callback: () => void
) {
	var data = new FormData();
	data.append("data", JSON.stringify(args.data));
	data.append("doc", args.file);

	axios
		.post(MAIN_URL + P.ResumeUpdate, data, {
			withCredentials: true,

			headers: { "Content-Type": "multipart/form-data" },
		})
		.then(function (response) {
			callback();
		})
		.catch(function (response) {
			console.error(response);
		});
}

export function GetStatuses(
	args: { filter_by: StatusFilter },
	callback: (resp: ResponseContainer<Status[]>) => void
) {
	request<ResponseContainer<Status[]>>(P.StatusList, args, callback);
}

export function GetTests(
	args: Filter<TestFilter, TestSearch>,
	callback: (resp: ResponseContainer<ArrayContainer<TestTable>>) => void
) {
	request<ResponseContainer<ArrayContainer<TestTable>>>(
		P.TestList,
		args,
		callback
	);
}

export function CreateTest(
	args: TestCreate,
	callback: (resp: ResponseContainer<{ id: number }>) => void
) {
	request<ResponseContainer<{ id: number }>>(P.TestCreate, args, callback);
}

export function UpdateTest(
	args: TestCreate,
	callback: (resp: ResponseContainer<{ id: number }>) => void
) {
	request<ResponseContainer<{ id: number }>>(P.TestUpdate, args, callback);
}

export function DeleteTest(
	args: { id: number; id_question?: number; is_delete: boolean },
	callback: (resp: ResponseContainer<{ id: number }>) => void
) {
	request<ResponseContainer<{ id: number }>>(P.TestDelete, args, callback);
}

export function GetTest(
	args: { id: number; id_candidate?: number },
	callback: (resp: ResponseContainer<TestCreate>) => void
) {
	request<ResponseContainer<TestCreate>>(P.TestGet, args, callback);
}

export function GetUserTests(
	args: { id_candidate: number },
	callback: (resp: ResponseContainer<UserTest[]>) => void
) {
	request<ResponseContainer<UserTest[]>>(P.TestsUser, args, callback);
}

export function AproovedTest(
	args: ApprovedTest,
	callback: (resp: ResponseContainer<null>) => void
) {
	request<ResponseContainer<null>>(P.ApproveTest, args, callback);
}
